import React from 'react'

export const InterviewHandlersContext = React.createContext(undefined)
export const InterviewStateContext = React.createContext(undefined)
